import { LCARSBar, MiniLogo } from '@enterpress/holomatrix'
import { Github, Linkedin, Mail } from 'lucide-react'
import { useTranslation } from '../i18n/index'

/**
 * Footer - Simple footer with links and branding
 * 
 * Uses MiniLogo from holomatrix for brand consistency
 */
export function Footer() {
  const { t } = useTranslation()
  const currentYear = 2026

  return (
    <footer className="relative z-20 py-12 px-6 border-t border-[rgba(0,180,216,0.2)] bg-[rgba(5,5,8,0.9)]">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo and tagline */}
          <div className="text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start mb-2">
              <MiniLogo size={32} />
              <span className="text-xl font-bold text-white">EnterPress</span>
            </div>
            <p className="text-sm text-[rgba(232,244,248,0.5)]">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <a 
              href="#mission" 
              className="text-sm text-[rgba(232,244,248,0.6)] hover:text-white transition-colors"
            >
              {t('common.mission')}
            </a>
            <a 
              href="#infrastructure" 
              className="text-sm text-[rgba(232,244,248,0.6)] hover:text-white transition-colors"
            >
              {t('common.infrastructure')}
            </a>
            <a 
              href="#crew" 
              className="text-sm text-[rgba(232,244,248,0.6)] hover:text-white transition-colors"
            >
              {t('common.crew')}
            </a>
            <a 
              href="#features" 
              className="text-sm text-[rgba(232,244,248,0.6)] hover:text-white transition-colors"
            >
              {t('common.readyRoom')}
            </a>
            <a 
              href="#preview" 
              className="text-sm text-[rgba(232,244,248,0.6)] hover:text-white transition-colors"
            >
              {t('common.preview')}
            </a>
          </div>

          {/* Social links */}
          <div className="flex items-center gap-4">
            <a 
              href="https://github.com/enterpress-ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] flex items-center justify-center text-[rgba(232,244,248,0.6)] hover:text-white hover:border-[rgba(255,255,255,0.3)] transition-all"
            >
              <Github size={18} />
            </a>
            <a 
              href="https://www.linkedin.com/company/enterpress-ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] flex items-center justify-center text-[rgba(232,244,248,0.6)] hover:text-white hover:border-[rgba(255,255,255,0.3)] transition-all"
            >
              <Linkedin size={18} />
            </a>
            <a 
              href="mailto:hello@enterpress.ai"
              className="w-10 h-10 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] flex items-center justify-center text-[rgba(232,244,248,0.6)] hover:text-white hover:border-[rgba(255,255,255,0.3)] transition-all"
            >
              <Mail size={18} />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="my-8 flex items-center gap-4">
          <LCARSBar color="purple" size="sm" className="flex-1" />
          <span className="text-xs text-[rgba(232,244,248,0.3)] font-mono">
            {t('common.stardate')} {new Date().toISOString().slice(0, 10).replace(/-/g, '.')}
          </span>
          <LCARSBar color="purple" size="sm" className="flex-1" />
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-xs text-[rgba(232,244,248,0.4)]">
            {t('footer.copyright')}
          </p>
          <p className="text-xs text-[rgba(232,244,248,0.3)] mt-2">
            {t('footer.quote')}
          </p>
        </div>
      </div>
    </footer>
  )
}
